import { render } from "./WarrantyDashboard.vue?vue&type=template&id=c6a24a22"
import script from "./WarrantyDashboard.vue?vue&type=script&lang=js"
export * from "./WarrantyDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__